import Decimal from "decimal.js";

export function areFiltersEmpty(fromValue: any): boolean {
    return Object.values(fromValue).every((x: any) => !x || (Array.isArray(x) && !x.length));
}

export function groupByGPI(array: any[], totalPerGroupKey: string = null, arrayKeyName: string = 'records'): any[] {
    const sortObjByProperty = array.reduce((rv, x) => {
        (rv[x['gpi']] = rv[x['gpi']] || []).push(x);
        return rv;
      }, {});
      
      const result = Object.entries(sortObjByProperty).map(([k, v]) => ({
        header: getGroupedBySimilarGroupHeader(<any>v),
        [arrayKeyName]: v
    }));
    
      if (totalPerGroupKey) {
        result.forEach((item: any) => {
            item.totalPerGroup = (item.records as any[])?.map(x => x?.[totalPerGroupKey])
                ?.reduce((accumulator, currentValue) => new Decimal(accumulator).add(new Decimal(currentValue)));
        });
    }
    
    result.sort((a, b) => {
      if (a.header === 'N/A' && b.header !== 'N/A') {
          return 1;
      } else if (a.header !== 'N/A' && b.header === 'N/A') {
          return -1;
      } else {
          return 0;
      }
  });

  return result;
}


export function getGroupedBySimilarGroupHeader(groupRecords: any[]): string {
    if (!groupRecords?.[0]?.friendlyName) {
        throw 'friendly name is required';
    }
    const name = groupRecords[0]?.gpi ? groupRecords[0]?.friendlyName : 'N/A';

    return name.includes('|') ?
        name.split('|')[1] : name;
}
